import { z } from 'zod';

export const setQrCodeContentReqDto = z.object({
  'qr-code-content': z.string().max(2048),
});

export type SetQrCodeContentResDto = z.infer<typeof setQrCodeContentReqDto>;
